import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import MainImageCardDashboard from '../../../components/Cards/MainImageCardDashboard';
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import { skin } from "../../../constants";


export default function SkinCard() {

return (
<>

    <MainImageCardDashboard

        content = {<HeaderCardSmall cardheadline={'Skin Health'} /> }

        iconbuttons = {<>               

                        <Tooltip title="Neurology Health" placement="bottom">
                                <IconButton component={RouterLink} to="/SkinWelcome"  size="large">
                                        <SplitscreenIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  

        photo = { skin }  

    />

</>
)};
